import axios from 'axios';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import md5 from 'js-md5';
import "./getAppUserInfo"

const Base64 = require('js-base64').Base64;
const Axios = axios.create({
  baseURL:"https://webservice.paperbanker.com/",
  // baseURL: "http://47.92.104.146/",
  headers: {
    'Authorization': 'Bearer ' + GETTOKEN(),
    'content-type': 'application/json',
    'source': 'h5',
  }
});

function GETTOKEN() {
    if (localStorage.getItem("tokenInfo") != null) {
      var userData = JSON.parse(atob(window.localStorage.getItem("tokenInfo")));
      return userData.token;
    }

}

function GETRANDOMKEY() {
  if (localStorage.getItem("tokenInfo") != null) {
    var userData = JSON.parse(atob(window.localStorage.getItem("tokenInfo")));
    return userData.randomKey;
  }

}

function getPostData(postData) {
  console.log(postData)
  var jsonData = JSON.stringify(postData);
  var base64Data = Base64.encode(jsonData);
  var base64Data_randomKey = base64Data + GETRANDOMKEY();
  var md5Data = md5(base64Data_randomKey);
  var data = JSON.stringify({
    'object': base64Data.replace(/\+/g, '%2B'),
    'sign': md5Data
  });

  return data;
};


var num = 0;
// 请求拦截器
Axios.interceptors.request.use(config => {
    num++;
    Indicator.open({
      spinnerType: 'fading-circle'
    });
    return config;
},
  error => {
    num--;
    Indicator.close();
    Toast({
      message: '网络错误,请稍后重试!'
    });
    return Promise.reject(error);
  }
);

// 响应拦截器
Axios.interceptors.response.use(
  response => {
    num--;
    if (num <= 0) {
      Indicator.close();
    }
    return response.data;
  },
  error => {
    num--;
    Indicator.close();
    return Promise.reject(error);
  }
);
// 获取用户token randomkey id

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data) {
  var postData = getPostData(data);
  return new Promise((resolve, reject) => {
    Axios.post(url, postData, {
      headers: {
        'Authorization': 'Bearer ' + GETTOKEN(),
        'content-type': 'application/json',
        'source': 'h5'
      }
    })
      .then(response => {
        if (response.code === '200') {
          resolve(response);
        } else {
          reject(response);
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function GETID() {
  if (localStorage.getItem("tokenInfo") != null) {
    var userData = JSON.parse(atob(window.localStorage.getItem("tokenInfo")));
    return userData.userId;
  }
}




// WEBPACK FOOTER //
// ./src/config/server.js